import React from "react";
import classes from "./ProductCard.module.css";

export interface ProductCardProps {
  isInnovative?: boolean;
  productClass: string;
  productName: string | null;
  productDescription?: string;
  tags: string[];
}

export const ProductCard = ({
  isInnovative = false,
  productClass,
  productName,
  productDescription,
  tags,
}: ProductCardProps) => {
  //没有该类产品的情况
  if (productName === null && tags.length === 0) {
    return (
      <div className={classes.na_product_card}>
        <h1 className={classes.product_type}>{productClass}</h1>
        <h2 className={classes.na_product_name}>
          N/A <SVG_Alert />
        </h2>
        <p>not offering any products or Service in this field yet.</p>
      </div>
    );
  }

  return (
    <div className={classes.product_card}>
      <h1 className={classes.product_type}>{productClass}</h1>
      <h2
        className={
          isInnovative ? classes.product_name : classes.product_name_black
        }
      >
        {isInnovative && <SVG_Stars />}
        {productName}
      </h2>
      {productDescription && <p>{productDescription}</p>}
      <ul>
        {Array.isArray(tags) &&
          tags.map((tag, index) => {
            return <li key={index}>{tag}</li>;
          })}
      </ul>
    </div>
  );
};

export const SVG_Stars = () => {
  return (
    <svg
      width="2.1rem"
      height="2.1rem"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.1248 23.625C34.1282 24.1601 33.9656 24.6832 33.6594 25.1221C33.3533 25.561 32.9186 25.8943 32.4153 26.0761L23.9415 29.1933L20.8243 37.6605C20.6397 38.162 20.3057 38.5948 19.8674 38.9006C19.4291 39.2063 18.9076 39.3702 18.3732 39.3702C17.8388 39.3702 17.3173 39.2063 16.879 38.9006C16.4407 38.5948 16.1067 38.162 15.9221 37.6605L12.7967 29.2031L4.3278 26.0859C3.82631 25.9013 3.39351 25.5674 3.08779 25.1291C2.78208 24.6908 2.61816 24.1692 2.61816 23.6348C2.61816 23.1005 2.78208 22.5789 3.08779 22.1406C3.39351 21.7023 3.82631 21.3683 4.3278 21.1838L12.8016 18.0666L15.9188 9.5993C16.1034 9.09781 16.4374 8.665 16.8757 8.35929C17.314 8.05357 17.8355 7.88966 18.3699 7.88966C18.9043 7.88966 19.4258 8.05357 19.8641 8.35929C20.3024 8.665 20.6364 9.09781 20.821 9.5993L23.9382 18.0731L32.4055 21.1903C32.908 21.3695 33.3429 21.6996 33.6507 22.1354C33.9584 22.5712 34.124 23.0915 34.1248 23.625ZM24.9373 7.875H27.5623V10.5C27.5623 10.8481 27.7006 11.1819 27.9468 11.4281C28.1929 11.6742 28.5267 11.8125 28.8748 11.8125C29.2229 11.8125 29.5568 11.6742 29.8029 11.4281C30.0491 11.1819 30.1873 10.8481 30.1873 10.5V7.875H32.8123C33.1604 7.875 33.4943 7.73672 33.7404 7.49058C33.9866 7.24444 34.1248 6.9106 34.1248 6.5625C34.1248 6.2144 33.9866 5.88056 33.7404 5.63442C33.4943 5.38828 33.1604 5.25 32.8123 5.25H30.1873V2.625C30.1873 2.2769 30.0491 1.94306 29.8029 1.69692C29.5568 1.45078 29.2229 1.3125 28.8748 1.3125C28.5267 1.3125 28.1929 1.45078 27.9468 1.69692C27.7006 1.94306 27.5623 2.2769 27.5623 2.625V5.25H24.9373C24.5892 5.25 24.2554 5.38828 24.0093 5.63442C23.7631 5.88056 23.6248 6.2144 23.6248 6.5625C23.6248 6.9106 23.7631 7.24444 24.0093 7.49058C24.2554 7.73672 24.5892 7.875 24.9373 7.875ZM39.3748 13.125H38.0623V11.8125C38.0623 11.4644 37.9241 11.1306 37.6779 10.8844C37.4318 10.6383 37.0979 10.5 36.7498 10.5C36.4017 10.5 36.0679 10.6383 35.8218 10.8844C35.5756 11.1306 35.4373 11.4644 35.4373 11.8125V13.125H34.1248C33.7767 13.125 33.4429 13.2633 33.1968 13.5094C32.9506 13.7556 32.8123 14.0894 32.8123 14.4375C32.8123 14.7856 32.9506 15.1194 33.1968 15.3656C33.4429 15.6117 33.7767 15.75 34.1248 15.75H35.4373V17.0625C35.4373 17.4106 35.5756 17.7444 35.8218 17.9906C36.0679 18.2367 36.4017 18.375 36.7498 18.375C37.0979 18.375 37.4318 18.2367 37.6779 17.9906C37.9241 17.7444 38.0623 17.4106 38.0623 17.0625V15.75H39.3748C39.7229 15.75 40.0568 15.6117 40.3029 15.3656C40.5491 15.1194 40.6873 14.7856 40.6873 14.4375C40.6873 14.0894 40.5491 13.7556 40.3029 13.5094C40.0568 13.2633 39.7229 13.125 39.3748 13.125Z"
        fill="url(#paint0_linear_3119_11187)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3119_11187"
          x1="1.13156"
          y1="5.63092"
          x2="37.6397"
          y2="11.9616"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1522" />
          <stop offset="1" stopColor="#E66E48" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const SVG_Alert = () => {
  return (
    <svg
      width="2rem"
      height="2.05rem"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="2rem" height="2rem" rx="20" fill="#FEEFEF" />
      <path
        d="M19.375 21.125V16.75C19.375 16.5842 19.4409 16.4253 19.5581 16.3081C19.6753 16.1909 19.8342 16.125 20 16.125C20.1658 16.125 20.3247 16.1909 20.4419 16.3081C20.5592 16.4253 20.625 16.5842 20.625 16.75V21.125C20.625 21.2908 20.5592 21.4497 20.4419 21.5669C20.3247 21.6842 20.1658 21.75 20 21.75C19.8342 21.75 19.6753 21.6842 19.5581 21.5669C19.4409 21.4497 19.375 21.2908 19.375 21.125ZM28.125 17.6524V23.3477C28.1255 23.5119 28.0934 23.6746 28.0305 23.8262C27.9676 23.9779 27.8752 24.1156 27.7586 24.2313L23.7313 28.2586C23.6156 28.3752 23.4779 28.4676 23.3262 28.5305C23.1746 28.5934 23.0119 28.6255 22.8477 28.625H17.1524C16.9881 28.6255 16.8255 28.5934 16.6738 28.5305C16.5221 28.4676 16.3844 28.3752 16.2688 28.2586L12.2414 24.2313C12.1248 24.1156 12.0324 23.9779 11.9695 23.8262C11.9066 23.6746 11.8745 23.5119 11.875 23.3477V17.6524C11.8745 17.4881 11.9066 17.3255 11.9695 17.1738C12.0324 17.0221 12.1248 16.8844 12.2414 16.7688L16.2688 12.7414C16.3844 12.6248 16.5221 12.5324 16.6738 12.4695C16.8255 12.4066 16.9881 12.3745 17.1524 12.375H22.8477C23.0119 12.3745 23.1746 12.4066 23.3262 12.4695C23.4779 12.5324 23.6156 12.6248 23.7313 12.7414L27.7586 16.7688C27.8752 16.8844 27.9676 17.0221 28.0305 17.1738C28.0934 17.3255 28.1255 17.4881 28.125 17.6524ZM26.875 17.6524L22.8477 13.625H17.1524L13.125 17.6524V23.3477L17.1524 27.375H22.8477L26.875 23.3477V17.6524ZM20 23C19.8146 23 19.6333 23.055 19.4792 23.158C19.325 23.261 19.2048 23.4074 19.1339 23.5787C19.0629 23.75 19.0443 23.9385 19.0805 24.1204C19.1167 24.3023 19.206 24.4693 19.3371 24.6004C19.4682 24.7315 19.6353 24.8208 19.8171 24.857C19.999 24.8932 20.1875 24.8746 20.3588 24.8036C20.5301 24.7327 20.6765 24.6125 20.7795 24.4584C20.8825 24.3042 20.9375 24.1229 20.9375 23.9375C20.9375 23.6889 20.8387 23.4504 20.6629 23.2746C20.4871 23.0988 20.2486 23 20 23Z"
        fill="#4F050E"
      />
    </svg>
  );
};
